<template>
    <div class="card tyre border-0">
        <div class="card-header p-0 border-0 d-block d-xxl-none">
            <tyre-banners v-if="showBanner" :contentOnly="true" promo-class="bg-secondary text-white" :banners="banners" :tyre="tyre"></tyre-banners>
        </div>
        <div class="card-body border secondary-border" :class="[showBanner ? 'rounded-bottom' : 'rounded', featured ? 'featured' : '']">
            <div class="text-center row">
                <div class="col-12 col-xxl-2 align-items-center d-flex mb-2 mb-xxl-0">
                    <div class="featured-label w-100 h-100 p-2 rounded d-inline-block d-lg-flex align-items-center bg-secondary text-white">
                        <b class="d-inline-block d-lg-block text-center w-100">{{ tyre.view_label_1 }}<br class="d-none d-xxl-block"> {{ tyre.view_label_2 }}</b>
                    </div>
                </div>
                <div class="col-3 col-xxl-2">
                    <div class="position-relative">
                        <img :src="tyre.brand_image ? tyre.brand_image_url : tyre.brand_image_url + 'generic.png'" class="brand-image shadow-sm rounded img-fluid" :alt="tyre.brand + ' logo'" height="40"/>
                    </div>
                    <div class="tyre-image">
                        <a :href="this.baseUrl + tyre.tyre_info_url">
                            <img :src="tyre.image_url" class="img-fluid" :alt="tyre.brand + ' ' + tyre.tyre_range + ' logo'" height="135" @error="replaceByDefault"/>
                        </a>
                        <fitments :fitments="tyre.fitments" :fitment-summary="false"></fitments>
                    </div>
                </div>
                <div class="col-5 col-xxl-3 text-start pe-0">
                    <div class="row">
                        <div class="col-12 col-xxl-5">
                            <b>{{ tyre.brand }}</b>
                            <p class="mb-0">{{ tyre.tyre_range  }}</p>
                            <p class="mb-0">{{ tyre.description }}</p>
                            <div v-if="tyre.tyre_video" class="mb-1 mb-xxl-0">
                                <checkatyre-tyre-video
                                    custom-style="etyres"
                                    :multi-video="true"
                                    .tyre-video-details="tyre.tyre_video"
                                    :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                                ></checkatyre-tyre-video>
                            </div>
                        </div>
                        <div class="col-12 col-xxl-7">
                            <specialisms :tyre="tyre"></specialisms>
                            <rating-labels :fuel="tyre.fuel" :wet="tyre.wet" :decibels="tyre.decibels" :noise-rating="tyre.noise_rating"></rating-labels>
                            <new-awards :awards="tyre.award_badges" :tyre-url="tyre.tyre_info_url"></new-awards>
                            <div class="mt-2">
                                <reviews
                                    :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                                ></reviews>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-none d-xxl-flex col-xxl-2">
                    <tyre-banners v-if="showBanner" :contentOnly="true" promo-class="bg-secondary text-white" :banners="banners" :tyre="tyre"></tyre-banners>
                </div>
                <div class="col-4 col-xxl-3 text-start">
                    <div class="row">
                        <div class="col-12 col-xxl-6">
                            <b class="price">&pound;{{ tyre.display_price }}</b>
                            <p class="mb-0 per d-xxl-inline-block ms-xxl-2">Per tyre</p>
                            <select name="quantity" id="quantity" class="form-control my-2" v-model="quantity">
                                <option v-for="index in 5" :key="index" :value="index">{{ index }}</option>
                            </select>
                        </div>
                        <div class="col-12 col-xxl-6">
                            <button class="btn btn-primary w-100" :class="buttonColour" @click="trackAndAdd()">
                                {{ tyreText }}
                            </button>
                            <earliest-fitting
                                v-if="this.$parent.$parent.updatedPostcode && this.$parent.$parent.homeDelivery == false"
                                :fitting-today="tyre.fitting_today"
                                :fitting-tomorrow="tyre.fitting_tomorrow"
                                :earliest-fitting-date="tyre.earliest_fitting_date"
                                :postcode="postcode"
                            ></earliest-fitting>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tyre from '@shared/mixins/tyre';
    export default {
        props: ['tyre', 'banners', 'basket', 'postcode', 'featured'],
        components: {
        	
        },
        mixins: [tyre],
        data() {
            return {
                quantity: this.$parent.$parent.quantity,
                featuredTopSpotFlag: false
            }
        },
        mounted() {
        },
        methods: {
            trackAndAdd() {
                //Track Featured Tyre Added To Basket
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('FeaturedTyre', {
                        'event_category' : 'Featured',
                        'event_label' : 'Added'
                    });
                }
                else {
                    console.log('gtag not loaded');
                }

                this.$parent.$parent.addTyreToBasket(this.tyre.st_code, this.quantity)
            }
        },
        computed: {
            tyreBorderColor() {
                let border = 'secondary';

                return border;
            },
        }
    }
</script>
<style lang="scss" scoped>
    .featured-tyres {
        @media screen and (min-width: 1400px) {
            .col {
                &:first-of-type {
                    .featured {
                        border-top-left-radius: 4px !important;
                        border-top-right-radius: 4px !important;
                    }
                }
                &:last-of-type {
                    .featured {
                        border-bottom-left-radius: 4px !important;
                        border-bottom-right-radius: 4px !important;
                        border-bottom: 2px solid #0064EF !important;
                    }
                }
            }
        }
    }
    .tyre {
        //temporary .card-header styles
        .card-header {
            background-color: transparent;
            max-height: 70px;
        }
        .card-body {
            position: relative;
            overflow: hidden;
            &.featured {
                @media screen and (min-width: 1400px) {
                    border-radius: 0 !important;
                    border-bottom: 0 !important;
                }
            }
            .brand-image {
                padding: 5px;
                background-color: #fff;
                @media screen and (min-width: 1400px) {
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 2;
                    width: 78px;
                }
            }
            .featured-label {
                b {
                    font-size: 20px;
                    padding: 15px 0;
                    line-height: 20px;
                }
            }
            .tyre-image {
                position: relative;
                @media screen and (min-width: 1400px) {
                    max-height: 88px;
                    color: red;
                }
                img {
                    max-height: 100%;
                    @media screen and (min-width: 1400px) {
                        max-width: 140px;
                        max-height: 170px;
                    }
                }
                @media screen and (min-width: 1400px) {
                    :deep(.fitments) {
                        top: 45px !important;
                    }
                }
            }
            .price {
                font-size: 22px;
            }
            .per {
                font-size: 12px;
            }
            .tyre-info-badge {
                position: absolute;
                bottom: 5px;
                left: -5px;
                text-align: left;
                div:nth-of-type(2) {
                    margin-top: 5px;
                }
            }
        }
    }
</style>